module.exports = __webpack_public_path__ + "img/sofia-veciana-byn.bbd77290.jpg";